import deactivate from '../Services/deactivate'

export default () => (dispatch) => {
  
  dispatch(deactivate())

}
